import React, { useState, useEffect } from "react";
import { Button, notification, Modal } from "antd";
import { Redirect } from "react-router-dom";

import axios from "axios";

import Header from "../../User/Header";
import ModalLoading from "../../shared/components/Modals/ModalLoading";
import NotasTurmaDestino from "../Transferencias/ImportarNotas/NotasTurmaDestino";

const confirm = Modal.confirm;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const ImportarNotas = () => {
    const [nomeAluno, setNomeAluno] = useState("");
    const [turmaOrigem, setTurmaOrigem] = useState(null);
    const [turmaDestino, setTurmaDestino] = useState(null);
    const [disciplinasDestino, setDisciplinasDestino] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(true);
    const [modalMessage, setModalMessage] = useState("Carregando as disciplinas e seus campos de avaliação...");

    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");

    const carregarInfosAluno = () => {
        const alunoId = sessionStorage.getItem("alunoId");

        axios({
            method: "get",
            url: "/api/colaboradores/utilizador-nome",
            params: {
                utilizadorid: alunoId
            }
        })
            .then(response => {
                setNomeAluno(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar informações do aluno.");
            });
    };

    const montarDisciplinasAvaliacoes = () => {
        const turmaDestinoId = sessionStorage.getItem("turmaDestinoId");
        const alunoId = sessionStorage.getItem("alunoId");

        if (!turmaDestinoId) {
            openNotificationWithIcon("warning", "Aviso", "Faltando dados para poder carregar as avaliações");
            return;
        }

        axios({
            method: "get",
            url: "/api/importacoes/carregar-disciplinas-avaliacoes",
            params: {
                turmaDestinoId,
                alunoId
            }
        })
            .then(response => {
                var resultado = response.data.data;
                setTurmaDestino(resultado[0]);
                setModalLoading(false);
            })
            .catch(error => {
                setLoading(false);
                openNotificationWithIcon("error", "Erro", error.response?.data?.errorMessage);
                setModalLoading(false);
            });
    };

    const guardarNotas = () => {
        confirm({
            title: "Confirmar notas",
            content: "Tem a certeza que pretende salvar estas notas na turma?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                setModalMessage("A salvar notas... Aguarde um momento.");
                setModalLoading(true);

                const alunoId = sessionStorage.getItem("alunoId");

                axios({
                    method: "post",
                    url: "/api/importacoes/guardar-notas-importadas",
                    params: {
                        alunoId
                    },
                    data: disciplinasDestino
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Notas salvas com sucesso na turma.");
                        setModalLoading(false);
                        voltarHome();
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response?.data?.errorMessage);
                        setModalLoading(false);
                    });
            }
        });
    };

    const voltarHome = () => {
        ["alunoId", "turmaDestinoId"].forEach(key => sessionStorage.removeItem(key));

        setRedirectLink(sessionStorage.getItem("backUrl"));
        setRedirect(true);
    };

    useEffect(() => {
        carregarInfosAluno();
        montarDisciplinasAvaliacoes();
    }, []);

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <Header titulo={`Inserir notas de ${nomeAluno}`} />
            <div className="container container-body" style={{ display: "flex", justifyContent: "center" }}>
                <div className="bloco-conteudo" style={{ width: "60%", boxSizing: "unset", position: "unset" }}>
                    <div className="mono-bloco">
                        <NotasTurmaDestino turma={turmaDestino} setDisciplinasDestino={setDisciplinasDestino} semAlertas semTag />
                    </div>
                    <div style={{ marginTop: 40, display: "flex", justifyContent: "left", gap: 10 }}>
                        <Button type="default" onClick={voltarHome}>
                            Cancelar
                        </Button>
                        <Button type="primary" onClick={guardarNotas}>
                            Salvar
                        </Button>
                    </div>
                </div>
            </div>
            <ModalLoading visible={modalLoading} text={modalMessage} />
        </>
    );
};

export default ImportarNotas;
